// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderCell":"Teams_tableHeaderCell__k_wnu"};